import {
  EXTERNAL_API_UPDATE_EXTERNAL_API_TYPE_BEGIN,
  EXTERNAL_API_UPDATE_EXTERNAL_API_TYPE_SUCCESS,
  EXTERNAL_API_UPDATE_EXTERNAL_API_TYPE_FAILURE,
  EXTERNAL_API_UPDATE_EXTERNAL_API_TYPE_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import axios from 'axios';
import { toast } from 'react-toastify';

export function updateExternalApiType(args = {}) {
  return (dispatch) => {
    dispatch({
      type: EXTERNAL_API_UPDATE_EXTERNAL_API_TYPE_BEGIN,
    });
    const { projectId, version, externalApiId, data } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.patch(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/external-api/update-type/${externalApiId}`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: EXTERNAL_API_UPDATE_EXTERNAL_API_TYPE_SUCCESS,
            data: res,
          });
          resolve(res);
          toast.success('Updated Type Successfully !', {});
          // window.location.reload();
        },
        (err) => {
          dispatch({
            type: EXTERNAL_API_UPDATE_EXTERNAL_API_TYPE_FAILURE,
            data: { error: err },
          });
          toast.error('Unable to Updated Type!', {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissUpdateExternalApiTypeError() {
  return {
    type: EXTERNAL_API_UPDATE_EXTERNAL_API_TYPE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case EXTERNAL_API_UPDATE_EXTERNAL_API_TYPE_BEGIN:
      return {
        ...state,
        updateExternalApiTypePending: true,
        updateExternalApiTypeError: null,
      };

    case EXTERNAL_API_UPDATE_EXTERNAL_API_TYPE_SUCCESS:
      return {
        ...state,
        updateExternalApiTypePending: false,
        updateExternalApiTypeError: null,
      };

    case EXTERNAL_API_UPDATE_EXTERNAL_API_TYPE_FAILURE:
      return {
        ...state,
        updateExternalApiTypePending: false,
        updateExternalApiTypeError: action.data.error,
      };

    case EXTERNAL_API_UPDATE_EXTERNAL_API_TYPE_DISMISS_ERROR:
      return {
        ...state,
        updateExternalApiTypeError: null,
      };

    default:
      return state;
  }
}
